import React, { memo } from 'react';
import Text from 'design-system/Text';
import { View, StyleSheet } from 'react-native';
import { rem } from 'design-system';
const AARNote = () => (<View style={styles.container}>
    <Text TextThin-16 Secondary>
      Average annual return (AAR) shows how much an investment has grown on average each year over a given period.
    </Text>
  </View>);
const styles = StyleSheet.create({
    container: {
        paddingVertical: rem(8),
        paddingHorizontal: rem(16),
    },
});
export default memo(AARNote);
